import React from 'react'
import { Input } from 'antd'
import styled from 'styled-components'

const { Search } = Input

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: clamp(220px, 36vw, 360px);

  .ant-input-affix-wrapper {
    background: #f6f8ff;
    border: 1px solid #d9e1ff;
    color: #1f2432;
    border-radius: 999px;
    padding-inline: 14px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus {
    border-color: #b8c4ff;
    box-shadow: 0 0 0 3px rgba(123, 140, 255, 0.25);
  }

  .ant-input {
    background: transparent;
    color: #1f2432;
  }

  .ant-input::placeholder {
    color: #8a94b8;
  }

  .ant-input-search-button {
    border-radius: 999px;
    margin-left: 8px;
    background: linear-gradient(135deg, #5f76ff 0%, #7f8dff 100%);
    border: none;
    box-shadow: 0 12px 28px -16px rgba(89, 111, 255, 0.55);
    font-weight: 600;
  }

  @media (max-width: 600px) {
    width: 100%;

    .ant-input-search-button {
      padding-inline: 16px;
    }
  }
`

const EventSearch = ({ search, searchData }) => {
	return (
		<SearchWrapper>
			<Search
				defaultValue={search}
				placeholder="검색어를 입력해 주세요."
				onSearch={searchData}
				allowClear
				enterButton="검색"
				style={{ width: '100%' }}
			/>
		</SearchWrapper>
	)
}

export default EventSearch

